"use client";

import * as React from "react";
import { Text, SectionCard, CardTitle, CardDescription, Section, Card, CardContent, CardFooter, CardHeader, Button } from "@/src/components";
import { InstallCommand } from "@/components/docs/install-command";

export default function DocsComponentsCard() {
  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Card
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            Displays a card with header, content, and footer sections.
          </Text>
        </div>
      </Section>

      {/* Installation */}
      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Installation</CardTitle>
              <CardDescription>Add this component to your project</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <InstallCommand command="npx shadcn@latest add @bluecopa-ui/card" />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Example</CardTitle>
              <CardDescription>A card with all sections</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <Card className="w-[350px]">
            <CardHeader>
              <CardTitle>Card Title</CardTitle>
              <CardDescription>Card description goes here.</CardDescription>
            </CardHeader>
            <CardContent>
              <p>Card content area for main information.</p>
            </CardContent>
            <CardFooter className="flex justify-between">
              <Button variant="outline">Cancel</Button>
              <Button>Save</Button>
            </CardFooter>
          </Card>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Components</CardTitle>}
          contentClassName="p-6"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 font-semibold">Component</th>
                <th className="text-left py-2 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">Card</td>
                <td className="py-2 text-muted-foreground">Root container with border and shadow</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">CardHeader</td>
                <td className="py-2 text-muted-foreground">Header section with padding</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">CardTitle</td>
                <td className="py-2 text-muted-foreground">Title text styling</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">CardDescription</td>
                <td className="py-2 text-muted-foreground">Description text styling</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">CardContent</td>
                <td className="py-2 text-muted-foreground">Main content area</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">CardFooter</td>
                <td className="py-2 text-muted-foreground">Footer section for actions</td>
              </tr>
            </tbody>
          </table>
        </SectionCard>
      </Section>
    </>
  );
}
